var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCallFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/ui/call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path Copy",
    d: "M17.6434 19.0813L15.1595 14.5543C15.1539 14.5569 13.767 15.2005 13.7035 15.2278C12.1233 15.9513 8.9072 10.0179 10.4521 9.23574L11.9215 8.55219L9.45744 4.0105L7.97178 4.70271C2.89121 7.20441 10.9579 22.0127 16.1549 19.7695C16.2402 19.7329 17.6377 19.084 17.6434 19.0813Z",
    fill: "#003764"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCallFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/call-fill.8028bbf3d40b781ce3a92d82335b5ba2.svg";